<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen scrollable transition="dialog-bottom-transition" :overlay="false">
    
      <v-card>
        <v-toolbar dark color="teal">
          <v-icon medium>{{ title.icon }}</v-icon>
          <v-toolbar-title>{{ title.text }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>        
        
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
          <v-container fluid grid-list-md text-xs-center>
            <v-layout row wrap>

              <v-flex d-flex xs12 md6>
                <v-card>
                  <v-toolbar dark color="blue darken-3">
                    <v-toolbar-title>
                      รายละเอียดวิชา
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-subheader v-text="'กลุ่มวิชา'"></v-subheader>
                      <v-flex xs12 md6>
                        <v-radio-group v-model="item.subject.subjectType" row :rules="[rules.required]" required :readonly="!allowedRoles">
                          <template v-for="data in subjectTypeItems">
                            <v-radio :label="data.text" :value="data.value" ></v-radio>
                          </template>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-subheader v-text="'หลักสูตร'"></v-subheader>
                      <v-flex xs12 md8>
                        <v-radio-group v-model="item.courseType" row :rules="[rules.required2]" required :readonly="!allowedRoles">
                          <template v-for="data in courseTypeItems">
                            <v-radio :label="data.text" :value="data.value" ></v-radio>
                          </template>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-autocomplete
                        :items="subjectItems"
                        v-model="item.subject"
                        label="วิชา"
                        item-value="id"
                        item-text="label"
                        return-object
                        :rules="[rules.required3]"
                        required
                        :disabled="disabled"
                        clearable
                        :readonly="!allowedRoles"                       
                      ></v-autocomplete>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex d-flex xs12 md6>
                <v-card>
                  <v-toolbar dark color="green darken-3">
                    <v-toolbar-title>
                      เวลา
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs4>
                      <v-subheader v-text="'วันที่เริ่มต้นคลาส'"></v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-menu
                          ref="menuStartDate"
                          :close-on-content-click="false"
                          v-model="menuStartDate"
                          :nudge-right="40"
                          :return-value.sync="item.startDate"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                          :readonly="!allowedRoles"
                        >
                          <v-text-field
                            slot="activator"
                            :value="date(item.startDate)"
                            label="วันที่"
                            prepend-icon="event"
                            readonly
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                          <v-date-picker v-model="item.startDate" @input="$refs.menuStartDate.save(item.startDate)" no-title locale="th-Th" :readonly="!allowedRoles"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader v-text="'วันที่สิ้นสุดต้นคลาส'"></v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-menu
                          ref="menuEndDate"
                          :close-on-content-click="false"
                          v-model="menuEndDate"
                          :nudge-right="40"
                          :return-value.sync="item.endDate"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                          :readonly="!allowedRoles"
                        >
                          <v-text-field
                            slot="activator"
                            :value="date(item.endDate)"
                            label="วันที่"
                            prepend-icon="event"
                            readonly
                            :rules="[rules.required]" 
                            required
                          ></v-text-field>
                          <v-date-picker v-model="item.endDate" @input="$refs.menuEndDate.save(item.endDate)" no-title locale="th-Th" :readonly="!allowedRoles"></v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>  
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex d-flex xs12 md6>
                <v-card>
                  <v-toolbar dark color="purple darken-3">
                    <v-toolbar-title>
                      ผู้รับผิดชอบ
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-autocomplete
                        :items="personItems"
                        v-model="item.instructor"
                        label="ประธานรายวิชา / ผู้รับผิดชอบดูแลรายวิชา"
                        item-value="id"
                        item-text="fullname"
                        return-object
                        :rules="[rules.required3]"
                        required
                        :readonly="!allowedRoles"                        
                      ></v-autocomplete>
                    </v-layout>
                    <v-layout row wrap>
                      <v-autocomplete
                        :items="personItems"
                        v-model="item.ed"
                        label="นักพัฒนาการศึกษา"
                        item-value="id"
                        item-text="fullname"
                        return-object
                        clearable
                        :readonly="!allowedRoles"                        
                      ></v-autocomplete>
                    </v-layout>
                    <v-layout row wrap>
                      <v-autocomplete
                        :items="personItems"
                        v-model="item.ta"
                        label="TA"
                        item-value="id"
                        item-text="fullname"
                        return-object
                        clearable
                        :readonly="!allowedRoles"                     
                      ></v-autocomplete>
                    </v-layout>
                    <v-layout row wrap>
                      <v-autocomplete
                        :items="personItems"
                        v-model="item.la"
                        label="LA"
                        item-value="id"
                        item-text="fullname"
                        return-object
                        clearable
                        :readonly="!allowedRoles"                      
                      ></v-autocomplete>
                    </v-layout>
                    <v-layout row wrap>
                      <v-autocomplete
                        :items="personItems"
                        v-model="item.ra"
                        label="RA"
                        item-value="id"
                        item-text="fullname"
                        return-object
                        clearable
                        :readonly="!allowedRoles"                        
                      ></v-autocomplete>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn dark color="grey white--text" @click="close">ปิด</v-btn>
          <v-spacer></v-spacer>
          <v-btn dark color="green" @click="onSubmit" :disabled="!valid" :loading="loading" v-if="allowedRoles">บันทึก</v-btn>
        </v-card-actions>
        
      </v-card>
      
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  props: ['academicYearId', 'dialog', 'item', 'title', 'allowedRoles'],
  data () {
    return {
      loading: false,
      valid: true,
      disabled: true,
      column: null,
      subjectType: null,
      courseType: null,
      subject: null,
      menuStartDate: false,
      startDate: null,
      menuEndDate: false,
      endDate: null,
      person: null,
      ed: null,
      ta: null,
      la: null,
      ra: null,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง',
        required2: (value) => value == "NORMAL" || value == "INTER" || value == "ARCH" || value == "RATC" || "ไม่สามารถเป็นค่าว่าง",
        required3: (value)  => !!value.id || 'ไม่สามารถเป็นค่าว่าง',
          
        
      },
      search: null
    }
  },
  computed: {
    ...mapGetters({
      courseTypeItems: 'activeCourse/courseTypeItems',
      personItems: 'person/personItems',
      subjectTypeItems: 'subject/subjectTypeItems',
      subjectItems: 'subject/subjectItems'
    })
  },
  mounted () {
    console.log('courseTypeItems', this.courseTypeItems)
    if(this.item.subject.subjectType) this.$store.dispatch('subject/fetchSubjectsBySubjectType', this.item.subject.subjectType)
  },
  methods: {
    close () {
      this.$emit('dialog', false)
    },
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        // console.log('onSubmit:', this.$refs.form.validate() )
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'activeCourse/update' : 'activeCourse/create'
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    },
    validate (value) {
      // console.log('validate called', value)
      if(this.item.courseType) return true
      return "no value" 
    }
  },
  watch: {
    'item.subject.subjectType' (val) {
      if(val) {
        this.disabled = false
        this.$store.dispatch('subject/fetchSubjectsBySubjectType', val)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/activeCourse/formDialog.vue